define('taoQtiItem/qtiItem/core/feedbacks/FeedbackInline',['taoQtiItem/qtiItem/core/feedbacks/Feedback'], function(Feedback){
    var FeedbackInline = Feedback.extend({});
    return FeedbackInline;
});
